<template>
  <el-dialog
    title="添加"
    :visible="showAddStatus"
    width="670px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="add-Form">
      <el-form ref="addDataForm" :model="addDataForm" :rules="formRules" label-width="140px">
        <el-form-item label="添加方式：" prop="selectRadio">
          <el-radio-group v-model="addDataForm.selectRadio">
            <el-radio :label="1">关联已有症状</el-radio>
            <el-radio :label="2">添加新症状</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addDataForm.selectRadio == 1" label="已有症状：" prop="patientSymptomItems">
          <!-- <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入" v-model="addDataForm.chiefComplaint"></el-input> -->
          <el-select
            v-model="addDataForm.patientSymptomItems"
            filterable remote reserve-keyword placeholder="请输入关键词"
            size="medium" style="width:100%" value-key="id"
            :remote-method="remoteMethod">
            <el-option
              v-for="item in symptomOptions"
              :key="item.value"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addDataForm.selectRadio == 2" label="症状描述：" prop="performance">
          <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入" v-model="addDataForm.performance"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm" size="small">取 消</el-button>
      <el-button type="primary" @click="saveForm" size="small">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mergeOrSave,pageStandardSymptom } from "@/api/addCourseOfDisease"
export default {
  props: {
    showAddStatus: {
      type: Boolean
    },
    selectRow: {
      type: Object
    }
  },
  data() {
    return {
      addDataForm: {
        performance: '',
        selectRadio: null,
        performance: '',
        patientSymptomItems: ''
      },
      symptomOptions: [],
      formRules: {
        selectRadio:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        performance:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        patientSymptomItems:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
      }
    }
  },
  async created() {},
  mounted() {},
  methods: {
    async remoteMethod(query) {
      if (query !== '') {
        let res = await pageStandardSymptom({
          name: query,
          enabled: true
        })
        if (res.code == 0) {
          this.symptomOptions = res.data.records
        }
      } else {
        this.symptomOptions = []
      }
    },
    handleClose() {
      this.$emit('update:showAddStatus', false)
    },
    cancelForm() {
      this.$emit('update:showAddStatus', false)
    },
    async saveForm() {
      let valRes
      this.$refs.addDataForm.validate(val => {
        valRes = val
      })
      if (!valRes) {
        return
      }
      let paramsObj = {}
      if (this.addDataForm.selectRadio == 1) {
        paramsObj = {
          mergeId: this.addDataForm.patientSymptomItems.id,
          mergeName: this.addDataForm.patientSymptomItems.name,
          performance: this.addDataForm.performance,
          patientId: this.$store.state.patientInfo.patientId,
          name: this.selectRow.name,
          id: this.selectRow.id
        }
      } else {
        paramsObj = {
          mergeId: '',
          mergeName: '',
          performance: this.addDataForm.performance,
          patientId: this.$store.state.patientInfo.patientId,
          name: this.selectRow.name,
          id: this.selectRow.id
        }
      }
      let res = await mergeOrSave(paramsObj)
      if (res.code == 0) {
        this.$message.success('保存成功')
        this.$emit('update:showAddStatus', false)
        this.$emit('getPatientSavePage')
        this.$store.dispatch("getPatientSavePage");
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__footer {
  text-align: center;
}
</style>
// <style lang="less">
// .message-del-confirm {
//   .el-button--primary {
//     background-color: #1A7BFC;
//   }
// }
// </style>
